module.exports = __webpack_public_path__ + "static/media/homepage_1.8f682b23.png";